"use client";

const LanguageSelector = () => {
    return (
      <div>
        <div className="gtranslate_wrapper"></div>
      </div>
    );
  }
  
  export default LanguageSelector;